(function() {
    'use strict';

    angular
        .module('szallodak-unique-offer-response', ['ui.bootstrap', 'daterangepicker']);
})();
